import image1 from '../../../../images/image1.svg';
import image2 from '../../../../images/image2.svg';
import image3 from '../../../../images/image3.svg';
import logo from '../../../../images/logo.svg';
const memberName={
    "HONORABLE_COMMISSION": "Hon'ble Commission",
    "CEC": "Chief Election Commissioner",
    "EC": "Election Commissioner",
    "M1": "Shri Gyanesh Kumar",
    "M2": "Dr. Sukhbir Singh Sandhu",
    "M3": "Dr. Vivek Joshi"
  }

const MembersDetails = () => {

  const HONORABLE_MEMBERS = [
    {
      name: memberName?.M1,
      title: memberName?.CEC,
      image: image1
    },
    {
      name: memberName?.M2,
      title: memberName?.EC,
      image: image2
    },
    {
      name: memberName?.M3,
      title: memberName?.EC,
      image: image3
    }
  ];

  return (
    <>
      <div style={styles.box} className='mt-auto'>
        <div>
         <img src={"/logo.svg"} fetchpriority="high"  alt="ECI" height="250" width="250" class="logoImage" ></img>
        </div>
      </div>

    </>
  )
}

const styles = {


  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#e6f0ff',
  },
  header: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#0052cc',
    color: '#fff',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: '16px',
  },
  main: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap', // makes it responsive
    gap: '20px',
    justifyContent: 'center',
  },
  box: {
  //  backgroundColor:" rgb(210, 228, 255)",
    // borderRadius: "22px",
    padding: "20px 20px 30px",
    width: "100%",
    maxWidth: "21rem",
    height:"fit-content"
  },
  input: {
    width: '100%',
    padding: '10px',
    marginBottom: '15px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  button: {
    width: '100%',
    padding: '10px',
    backgroundColor: '#0052cc',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
  },
  footer: {
    textAlign: 'center',
    padding: '10px',
    backgroundColor: '#003d99',
    color: '#fff',
  },
  card: {
    boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    display: 'flex',
    backgroundColor: '#fff',
    alignItems: 'center',
    marginBottom: '15px',
    padding: '4px 16px 4px 16px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    gap: '10px',

  },
  photo: {
    width: '60px',
    height: '60px',
    display: 'flex',
    backgroundColor: '#ddd',
    borderRadius: '50%',
  },
};

export default MembersDetails; 
